import { isTruthy } from 'corso-types';

export default function Address({
  name,
  address,
}: {
  name?: string;
  address: {
    line1: string;
    line2?: string | null;
    city: string;
    stateOrProvinceCode?: string | null;
    postalCode?: string | null;
    countryCode: string;
  };
}) {
  const locality = [
    address.city,
    address.stateOrProvinceCode,
    address.postalCode,
  ]
    .filter(isTruthy)
    .join(' ');

  return (
    <div className="flex flex-col gap-1 text-xs text-neutral-500">
      {name && <p>{name}</p>}
      <p>{address.line1}</p>
      {address.line2 && <p>{address.line2}</p>}
      {locality && <p>{locality}</p>}
      <p>{address.countryCode}</p>
    </div>
  );
}
